//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    cellHeader: ''
  }
}



// WEBPACK FOOTER //
// ./src/components/baseComponents/MyCellHeader.vue